module.exports = __webpack_public_path__ + "img/c5201812.c1609116.jpg";